import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CacheService } from "../services/cache-service";

@Injectable()
export class CacheInterceptor implements HttpInterceptor {

  constructor(
    private cacheService: CacheService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cacheKey = request.urlWithParams;
    const isCacheable = this.cacheService.isCacheableRequest(request.url);

    if (isCacheable) {
      const cachedResponse = this.cacheService.getCachedResponse(cacheKey);

      if (cachedResponse) {
        return of(cachedResponse);
      }
    }

    return next.handle(request).pipe(
      tap(event => {
        if (isCacheable && event instanceof HttpResponse) {
          this.cacheService.setCachedResponse(cacheKey, event);
        }
      })
    );
  }
}
